import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/gmsbnanonprod/frontend/frontastic/renderer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/gmsbnanonprod/frontend/helpers/analytics/GASnippet/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetupOTelSDK"] */ "/opt/build/repo/packages/gmsbnanonprod/frontend/helpers/utils/otelsetuo/SetupOTelSDK.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/build/repo/packages/gmsbnanonprod/frontend/providers/index.tsx");
